import { editorImageUploadModalComponent } from './editor-image-upload-modal.component';
import angularFileUpload from 'ng-file-upload';
import './editor-image-upload-modal.scss';

export const editorImageUploadModal = angular
	.module('common.components.editor.editorImageUploadModal', [
		angularFileUpload
	])
	.component('editorImageUploadModal', editorImageUploadModalComponent)
	.name;


// WEBPACK FOOTER //
// ./src/app/common/components/editor/editor-image-upload-modal/editor-image-upload-modal.module.js